import Login            from "../pages/auth/login";
import AdminDashboard    from "../pages/dashboard/AdminDashboard";
import EmployeeDashboard from "../pages/dashboard/EmployeeDashboard";
import DataBaseMangement from "../pages/database-mangement/Pages/DataBaseManagement";
import ImportData        from "../pages/database-mangement/Pages/ImportData";
import EmployeeMangement from "../pages/employee-mangement/EmployeeMangement.js";
import UserLogsPage      from "../pages/UserLogsPage";
import ProjectManagement from "../pages/project-management/ProjectManagement";
import ProjectBoard      from "../pages/project-management/ProjectBoard";
import ClosedProjects    from "../pages/project-management/ClosedProjects";
import ExpertRequests    from "../pages/website/ExpertRequests";
import ContactRequests   from "../pages/website/ContactRequests";
import PerformanceDashboard from "../pages/performance/PerformanceDashboard";
import SalesQLSync       from "../pages/database-mangement/Pages/SalesQLSync";
import ChatPage          from "../pages/chat/ChatPage";
import ChatApp           from "../pages/chat/ChatApp";
import ProfilePage       from "../pages/profile/ProfilePage";
import NoticeBoardPage   from "../pages/notices/NoticeBoardPage";
import { ROLES }         from "../constants";

// HR Module pages
import HrDashboard     from "../pages/hr/dashboard/HrDashboard";
import HrLocations     from "../pages/hr/locations/HrLocations";
import HrEmployees     from "../pages/hr/employees/HrEmployees";
import HrEmployeeDetail from "../pages/hr/employees/HrEmployeeDetail";
import HrPayroll       from "../pages/hr/payroll/HrPayroll";
import HrPayrollDetail from "../pages/hr/payroll/HrPayrollDetail";
import HrAssets        from "../pages/hr/assets/HrAssets";

const HR_ROLES = [ROLES.ADMIN, ROLES.HR];
const ALL_ROLES = [ROLES.ADMIN, ROLES.EMPLOYEE, ROLES.MANAGER, ROLES.HR];

// Sections mirror the sidebar groups; they appear as unlinked breadcrumb labels.
const SECTIONS = {
  OPERATIONS: "Operations",
  WEBSITE:    "Website",
  HR:         "HR",
};

// Each protected route carries header metadata:
//   title   - page heading shown in the header (pages can override it with usePageTitle)
//   section - sidebar group the page belongs to (inherited by child pages)
//   parent  - path of the parent route, for breadcrumbs of nested/detail pages
const routes = {
  public: [
    { path: "/", element: Login },
    // IRG Chat, the installable chat-only app. Public here because it signs people in by itself.
    { path: "/chat/*", element: ChatApp },
  ],
  admin: [
    { path: "/admin/dashboard",                    element: AdminDashboard,     allowedRoles: [ROLES.ADMIN], title: "Dashboard" },
    { path: "/admin/employee-mangement",            element: EmployeeMangement,  allowedRoles: [ROLES.ADMIN], title: "User Management", section: SECTIONS.OPERATIONS },
    { path: "/admin/user-management",               element: EmployeeMangement,  allowedRoles: [ROLES.ADMIN], title: "User Management", section: SECTIONS.OPERATIONS },
    { path: "/admin/database-mangement",            element: DataBaseMangement,  allowedRoles: [ROLES.ADMIN, ROLES.EMPLOYEE, ROLES.MANAGER], title: "Database", section: SECTIONS.OPERATIONS },
    { path: "/admin/import-data",                   element: ImportData,         allowedRoles: [ROLES.ADMIN, ROLES.EMPLOYEE, ROLES.MANAGER], title: "Import Data", section: SECTIONS.OPERATIONS },
    { path: "/admin/salesql-sync",                  element: SalesQLSync,        allowedRoles: [ROLES.ADMIN], title: "SalesQL Sync", section: SECTIONS.OPERATIONS },
    { path: "/admin/project-management",            element: ProjectManagement,  allowedRoles: [ROLES.ADMIN, ROLES.EMPLOYEE, ROLES.MANAGER], title: "Project Management", section: SECTIONS.OPERATIONS },
    { path: "/admin/closed-projects",               element: ClosedProjects,     allowedRoles: [ROLES.ADMIN, ROLES.EMPLOYEE, ROLES.MANAGER], title: "Closed Projects", section: SECTIONS.OPERATIONS },
    { path: "/admin/project-management/:projectId", element: ProjectBoard,       allowedRoles: [ROLES.ADMIN, ROLES.EMPLOYEE, ROLES.MANAGER], title: "Project Board", parent: "/admin/project-management" },
    { path: "/admin/user-logs",                     element: UserLogsPage,       allowedRoles: [ROLES.ADMIN], title: "User Activity Logs", section: SECTIONS.OPERATIONS },
    { path: "/admin/expert-requests",               element: ExpertRequests,     allowedRoles: [ROLES.ADMIN], title: "Expert Requests", section: SECTIONS.WEBSITE },
    { path: "/admin/contact-queries",               element: ContactRequests,    allowedRoles: [ROLES.ADMIN], title: "Contact Form Queries", section: SECTIONS.WEBSITE },
    { path: "/admin/performance-dashboard",         element: PerformanceDashboard, allowedRoles: [ROLES.ADMIN, ROLES.EMPLOYEE, ROLES.MANAGER], title: "Performance Dashboard" },
    { path: "/admin/chat",                          element: ChatPage,           allowedRoles: ALL_ROLES, title: "Chat" },
  ],
  employee: [
    { path: "/employee/dashboard", element: EmployeeDashboard, allowedRoles: [ROLES.EMPLOYEE, ROLES.MANAGER], title: "Dashboard" },
  ],
  hr: [
    { path: "/hr/dashboard",          element: HrDashboard,      allowedRoles: HR_ROLES, title: "HR Dashboard" },
    { path: "/hr/locations",          element: HrLocations,      allowedRoles: HR_ROLES, title: "Locations", section: SECTIONS.HR },
    { path: "/hr/employees",          element: HrEmployees,      allowedRoles: HR_ROLES, title: "Employees", section: SECTIONS.HR },
    { path: "/hr/employees/new",      element: HrEmployees,      allowedRoles: HR_ROLES, title: "New Employee", parent: "/hr/employees" },
    { path: "/hr/employees/:id/edit", element: HrEmployees,      allowedRoles: HR_ROLES, title: "Edit Employee", parent: "/hr/employees" },
    { path: "/hr/employees/:id",      element: HrEmployeeDetail, allowedRoles: HR_ROLES, title: "Employee Details", parent: "/hr/employees" },
    { path: "/hr/payroll",            element: HrPayroll,        allowedRoles: HR_ROLES, title: "Payroll", section: SECTIONS.HR },
    { path: "/hr/payroll/:id",        element: HrPayrollDetail,  allowedRoles: HR_ROLES, title: "Payroll Details", parent: "/hr/payroll" },
    { path: "/hr/assets",             element: HrAssets,         allowedRoles: HR_ROLES, title: "Assets", section: SECTIONS.HR },
  ],
  notices: [
    { path: "/notices", element: NoticeBoardPage, allowedRoles: ALL_ROLES, title: "Notice Board" },
  ],
  profile: [
    { path: "/profile",         element: ProfilePage, allowedRoles: ALL_ROLES, title: "My Profile" },
    { path: "/profile/:userId", element: ProfilePage, allowedRoles: ALL_ROLES, title: "Profile" },
  ],
};

export default routes;
